import * as z from "zod";

export const disconnectStayAiIntegration = {
  name: "disconnectStayAiIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
